import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import PageSkeleton from "./components/skeletons/PageSkeleton";
import ScrollToTop from "./components/ScrollToTop";
import lazyWithRetry from "./utils/lazyWithRetry";

const Home = lazyWithRetry(() => import("./pages/Home"));
const NewsEvents = lazyWithRetry(() => import("./pages/NewsEvents"));
const NewsDetail = lazyWithRetry(() => import("./pages/NewsDetail"));
const Updates = lazyWithRetry(() => import("./pages/Updates"));
const ContactUs = lazyWithRetry(() => import("./pages/ContactUs"));
const AboutUs = lazyWithRetry(() => import("./pages/AboutUs"));
const Downloads = lazyWithRetry(() => import("./pages/Departments/Downloads"));
const DptHome = lazyWithRetry(() => import("./pages/Departments/DptHome"));
const CourseScheme = lazyWithRetry(() => import("./pages/Departments/CourseScheme"));
const AdmHome = lazyWithRetry(() => import("./pages/Departments/AdmHome"));
const ProHome = lazyWithRetry(() => import("./pages/Programs/ProHome"));
const AdmissionHome = lazyWithRetry(() => import("./pages/Admission/AdmissionHome"));
const FacilitiesHome = lazyWithRetry(() => import("./pages/Facilities/FacilitiesHome"));
const Instruction = lazyWithRetry(() => import("./pages/Admission/Instruction"));
const AdmissionPolicy = lazyWithRetry(() => import("./pages/Admission/AdmissionPolicy"));
const SelfFinanceScheme = lazyWithRetry(() => import("./pages/Admission/SelfFinanceScheme"));
const FeeStructure = lazyWithRetry(() => import("./pages/Admission/FeeStructure"));
const HelpDesk = lazyWithRetry(() => import("./pages/Admission/HelpDesk"));
const EligibilityCriteria = lazyWithRetry(() => import("./pages/Admission/EligibilityCriteria"));
const SeatAllocation = lazyWithRetry(() => import("./pages/Admission/SeatAllocation"));
const FacultyListing = lazyWithRetry(() => import("./pages/FacultyDirectory/FacultyListing"));
const FacultyProfile = lazyWithRetry(() => import("./pages/FacultyDirectory/FacultyProfile"));
const FacHome = lazyWithRetry(() => import("./pages/Faculties/FacHome"));
const Career = lazyWithRetry(() => import("./pages/Career"));
const CareerDetail = lazyWithRetry(() => import("./pages/CareerDetail"));
const CareerApply = lazyWithRetry(() => import("./pages/CareerApply"));
const NotFound = lazyWithRetry(() => import("./pages/NotFound"));
const LeadershipProfile = lazyWithRetry(() => import("./pages/Leadership/LeadershipProfile"));
const FacilityDetail = lazyWithRetry(() => import("./pages/Facilities/FacilityDetail"));

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Suspense fallback={<PageSkeleton />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/NewsEvents" element={<NewsEvents />} />
          <Route path="/NewsDetail" element={<NewsDetail />} />
          <Route path="/Updates" element={<Updates />} />
          <Route path="/ContactUs" element={<ContactUs />} />
          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/Downloads" element={<Downloads />} />
          <Route path="/DptHome" element={<DptHome />} />
          <Route path="/CourseScheme" element={<CourseScheme />} />
          <Route path="/AdmHome" element={<AdmHome />} />
          <Route path="/ProHome" element={<ProHome />} />
          <Route path="/FacilitiesHome" element={<FacilitiesHome />} />
          <Route path="/AdmissionHome" element={<AdmissionHome />} />
          <Route path="/Instruction" element={<Instruction />} />
          <Route path="/AdmissionPolicy" element={<AdmissionPolicy />} />
          <Route path="/FeeStructure" element={<FeeStructure />} />
          <Route path="/SelfFinanceScheme" element={<SelfFinanceScheme />} />
          <Route path="/HelpDesk" element={<HelpDesk />} />
          <Route path="/EligibilityCriteria" element={<EligibilityCriteria />} />
          <Route path="/SeatAllocation" element={<SeatAllocation />} />
          <Route path="/Faculty" element={<FacultyListing />} />
          <Route path="/FacultyProfile" element={<FacultyProfile />} />
          <Route path="/FacHome" element={<FacHome />} />
          <Route path="/Careers" element={<Career />} />
          <Route path="/CareerDetail" element={<CareerDetail />} />
          <Route path="/CareerApply" element={<CareerApply />} />
          <Route path="/LeadershipProfile" element={<LeadershipProfile />} />
          <Route path="/FacilityDetail" element={<FacilityDetail />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
